import { useQuery } from "@tanstack/react-query";
import { brasilApiService, type BrasilApiBank } from "../services/external/brasil-api.service";

/**
 * Hook para buscar lista de bancos da Brasil API
 * Utiliza cache de 24 horas
 */
export function useBrasilApiBanks() {
  return useQuery<BrasilApiBank[]>({
    queryKey: ["brasil-api", "banks"],
    queryFn: () => brasilApiService.getBanks(),
    staleTime: 24 * 60 * 60 * 1000, // Cache por 24 horas
    retry: 2,
    retryDelay: 1000,
  });
}

// Re-exportar tipo para compatibilidade
export type { BrasilApiBank } from "../services/external/brasil-api.service";
